

function count() {
  var length = parseFloat(jQuery("input#length").val());
  var width = parseFloat(jQuery("input#width").val());
  var area = length * width;
  var uom = jQuery("select#each").val();
  var size_mt = jQuery("select#size_mt").val();
  var size_ft = jQuery("select#size_ft").val();
  var effect = jQuery("input[type=radio][name=effect]:checked").val();
  var result = 0;
  var pembagi = 0;
  if (uom == "mt") {
    if (size_mt == "16") {
      if (effect == "hd") {
        pembagi = 1.22;
      } else if (effect == "md") {
        pembagi = 2.44;
      } else if (effect == "ad") {
        pembagi = 4.88;
      }
    } else if (size_mt == "12") {
      if (effect == "hd") {
        pembagi = .75;
      } else if (effect == "md") {
        pembagi = 1.5;
      } else if (effect == "ad") {
        pembagi = 3.0;
      }
    } else if (size_mt == "8") {
      if (effect == "hd") {
        pembagi = 1.5;
      } else if (effect == "md") {
        pembagi = 3.0;
      } else if (effect == "ad") {
        pembagi = 6.0;
      }
    } else if (size_mt == "4") {
      if (effect == "hd") {
        pembagi = 3;
      } else if (effect == "md") {
        pembagi = 6;
      } else if (effect == "ad") {
        pembagi = 9;
      }
    }
  } else if (uom == "ft") {
    if (size_ft == 0) {
      if (effect == "hd") {
        pembagi = 4;
      } else if (effect == "md") {
        pembagi = 8;
      } else if (effect == "ad") {
        pembagi = 16;
      }
    } else if (size_ft == 1) {
      if (effect == "hd") {
        pembagi = 8;
      } else if (effect == "md") {
        pembagi = 16;
      } else if (effect == "ad") {
        pembagi = 32;
      }
    } else if (size_ft == 2) {
      if (effect == "hd") {
        pembagi = 14;
      } else if (effect == "md") {
        pembagi = 28;
      } else if (effect == "ad") {
        pembagi = 56;
      }
    } else if (size_ft == 3) {
      if (effect == "hd") {
        pembagi = 20;
      } else if (effect == "md") {
        pembagi = 40;
      } else if (effect == "ad") {
        pembagi = 80;
      }
    }
  }
  result = Math.ceil(parseFloat(area) / parseFloat(pembagi));
  jQuery("#total_all").val(result);
}
jQuery(document).ready(function ($) {
  $("#calculator-project").find("select#size_ft").parent().css("display", "none");
  $("input#area").val("0");
  $("input#total_all").val("0");
  $("#myModal")
  .find("input#length, input#width")
  .on("keyup", function () {
    if ($("input#length").val() == "" || $("input#width").val() == "") {
      $("input#area").val("0");
      $("input#total_all").val("0");
    } else {
      var length = parseFloat($("input#length").val());
      var width = parseFloat($("input#width").val());
      var a = length * width;
      if ($("#myModal").find("select#each").val() == "mt") {
        var size = parseFloat($("select#size_mt").val());
      } else {
        var size = parseFloat($("select#size_ft").val());
      }
      var nilai = (25 * 454) / 60;
      if (size == 4) {
        var nilai_akhir = (a * nilai) / 4;

      } else if (size == 8) {
        var nilai_akhir = (a * nilai) / 2;

      } else if (size == 12) {
        var nilai_akhir = a * nilai;

      } else if (size == 0) {
        var nilai_akhir = (a * nilai) / 0.75;
      } else if (size == 1) {
        var nilai_akhir = (a * nilai) / 0.5;
      } else if (size == 2) {
        var nilai_akhir = (a * nilai) / 0.25;
      } else if (size == 3) {
        var nilai_akhir = (a * nilai) / 0.125;
      }
      $("input#area").val(a);
      $("input#total_all").val(nilai_akhir.toFixed(2));
      count();
    }
  });
  $("#myModal")
  .find("select#size_ft")
  .on("change", function () {
    if ($("input#length").val() == "" || $("input#width").val() == "") {
      $("input#total_all").val("0");
    } else {
      var length = parseFloat($("input#length").val());
      var width = parseFloat($("input#width").val());
      var a = length * width;
      var size = parseFloat($("select#size_ft").val());
      var nilai = (25 * 454) / 60;
      if (size == 0) {
        var nilai_akhir = (a * nilai) / 0.75;
      } else if (size == 1) {
        var nilai_akhir = (a * nilai) / 0.5;
      } else if (size == 2) {
        var nilai_akhir = (a * nilai) / 0.25;
      } else {
        var nilai_akhir = (a * nilai) / 0.125;
      }
      $("input#total_all").val(nilai_akhir.toFixed(2));
    }
    count();
  });
  $("#myModal")
  .find("select#size_mt")
  .on("change", function () {
    if ($("input#length").val() == "" || $("input#width").val() == "") {
      $("input#total_all").val("0");
    } else {
      var length = parseFloat($("input#length").val());
      var width = parseFloat($("input#width").val());
      var a = length * width;
      var size = parseFloat($("select#size_mt").val());
      var nilai = (25 * 454) / 60;
      if (size == 4) {
        var nilai_akhir = (a * nilai) / 4;
        $("label.hd .mt_val").html("3/m2");
        $("label.md .mt_val").html("6/m2");
        $("label.ad .mt_val").html("9/m2");
      } else if (size == 8) {
        var nilai_akhir = (a * nilai) / 2;
        $("label.hd .mt_val").html("1.5/m2");
        $("label.md .mt_val").html("3/m2");
        $("label.ad .mt_val").html("6.0/m2");
      } else if (size == 12) {
        var nilai_akhir = (a * nilai) / 2;
        $("label.hd .mt_val").html(".75/m2");
        $("label.md .mt_val").html("1.5/m2");
        $("label.ad .mt_val").html("3.0/m2");
      } else {
        var nilai_akhir = a * nilai;
      }
      $("input#total_all").val(nilai_akhir.toFixed(2));
    }
    count();
  });
  $("#myModal")
  .find("select#each")
  .on("change", function () {
    $("input#length").val("");
    $("input#width").val("");
    $("input#area").val("0");
    $("input#total_all").val("0");
    if (this.value == "ft") {
      $("#calculator-project").find("select#size_ft").parent().css("display", "table-cell");
      $("#calculator-project").find("select#size_mt").parent().css("display", "none");


      $("#calculator-project").find(".ft").css("display", "inline-block");
      $("#calculator-project").find(".mt").css("display", "none");

    } else {
      $("#calculator-project").find("select#size_ft").parent().css("display", "none");
      $("#calculator-project").find("select#size_mt").parent().css("display", "table-cell");

      $("#calculator-project").find(".ft").css("display", "none");
      $("#calculator-project").find(".mt").css("display", "inline-block");
    }
  });
  $("#myModal")
  .find("input[type=radio][name=effect]")
  .change(function () {
    if (this.value == "hd" && this.checked) {
      $("#calculator-project img").attr("src", "https://glowstone.com/wp-content/uploads/2016/11/calc-img1.jpg");
    } else if (this.value == "md" && this.checked) {
      $("#calculator-project img").attr("src", "https://glowstone.com/wp-content/uploads/2016/11/calc-img1.jpg");
    } else if (this.value == "ad" && this.checked) {
      $("#calculator-project img").attr("src", "https://glowstone.com/wp-content/uploads/2016/11/calc-img1.jpg");
    }
    count();
  });
});




